import * as React from 'react';
import { useMemo } from 'react';
import { Column, Columns, Button } from 'lqx-react';
import { Policy, PolicyBuyerSchedule } from '../../../api/policy';
import { useLinked, useModelCopy } from '@type-r/react';
import { PolicyBuyersList } from './policy-buyers-list';
import { BackButton, ConfirmationButton } from '../../../shared';
import { Collection } from '@type-r/models';
import { BuyerEditTitle, VerticalContainer } from './shared';
import { PolicyBuyerForm } from './policy-buyer-form';

export const ConfirmBuyersDataStep = ({ policy, buyers, back }: { policy: Policy, buyers: Collection<PolicyBuyerSchedule>, back }) => {
    const validBuyers = useMemo(() => buyers.filter(buyer => buyer.validateBuyer()), [ buyers[ '_changeToken' ] ])
    const $selectedBuyer = useLinked(null);
    const defaultBuyer = useMemo(() => new PolicyBuyerSchedule(), [ true ]);
    const selectedBuyerCopy = useModelCopy($selectedBuyer.value || defaultBuyer);
    const $isSelectedBuyerValid = useLinked(false);
    const $areBuyersStored = useLinked(false);

    const goBack = () => {
        $selectedBuyer.set(null);
        $areBuyersStored.set(false);
        back();
    }

    const store = () => {
        policy.policyBuyerSchedules.assignFrom(validBuyers);
        $selectedBuyer.set(null);
        buyers.set(validBuyers);
        $areBuyersStored.set(true);
    }

    const deleteBuyer = () => {
        buyers.remove($selectedBuyer.value);
        $selectedBuyer.set(null);
    }

    const updateBuyer = () => {
        $selectedBuyer.value.assignFrom(selectedBuyerCopy);
    }

    return <>
        <Columns>
            <Column>
                <VerticalContainer>
                    <PolicyBuyersList buyers={ buyers } $selected={ $selectedBuyer } />
                    <Columns>
                        <Column>
                            <BackButton onClick={ goBack }>Back: Reload Buyers</BackButton>
                        </Column>
                        <Column>
                            <ConfirmationButton onClick={ store } disabled={ validBuyers.length <= 0 || $areBuyersStored.value }>Next: Store { validBuyers.length } buyers</ConfirmationButton>
                        </Column>
                    </Columns>
                </VerticalContainer>
            </Column>
            <Column>
                { $selectedBuyer.value &&
                    <>
                        <VerticalContainer>
                            <BuyerEditTitle>Manually enter a buyer to add to insurance policy</BuyerEditTitle>
                            <PolicyBuyerForm buyer={ selectedBuyerCopy } $isBuyerValid={ $isSelectedBuyerValid } />
                        </VerticalContainer>
                        <Columns>
                            <Column>
                                <Button onClick={ deleteBuyer }>Delete Buyer</Button>
                            </Column>
                            <Column>
                                <ConfirmationButton disabled={ !$isSelectedBuyerValid.value } onClick={ updateBuyer }>Update Buyer</ConfirmationButton>
                            </Column>
                        </Columns>
                    </> }
            </Column>
        </Columns>
    </>
};
